export const ENG_STRING_CONSTS = {
    ADMIN_ROLE_REQUIRED: 'Teams Administrator or Teams External Collaboration Admin role required. Please ensure you have one of these roles assigned in Azure AD. Contact your administrator to request the appropriate permissions.',
}